import React, { ReactNode } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import {
    DeleteButtonWithConfirmation,
    EditDesignButton,
    EmailButton,
    MarkAsDoneButton,
    UnArchiveButton
} from "../../common/button"
import { InventoryAdjustmentButton } from "../../common/button/InventoryAdjustmentButton"
import { StaticFooter } from "../../common/footer"
import { ProposalOpenButton, ProposalPreviewButton } from "../../proposal/components"
import IntlProps from "../../state/helpers/IntlProps"
import { StockDocumentAction } from "../../state/inventory/stockdocument/actions"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"
import { PricingTableSelector } from "../../state/pricing/selectors"
import {
    INVENTORY_STOCK_DIRECTION,
    STOCK_DOCUMENT,
    STOCK_DOCUMENT_FOOTER_MESSAGES,
    STOCK_DOCUMENTS
} from "../../utils/inventory"
import { StockDocumentFooterDropdownMenu } from "./StockDocumentFooterDropdownMenu"
import SendEmailModal from "../../common/email/sendemail.component"
import { ProjectSelector } from "../../state/project"
import { ProposalAction } from "../../state/proposal/actions"
import { ProposalSelector } from "../../state/proposal/selectors"

export const StockDocumentFooter = injectIntl((props: IntlProps) => {
    const containsAtLeastOneItem = useSelector(PricingTableSelector.containsItems)
    const docState = useSelector(StockDocumentSelector.getFooterState)
    const toEmail = useSelector(ProjectSelector.getToEmail)
    const isFetching  = useSelector(ProposalSelector.isFetching)

    const dispatch = useDispatch()
    const [modal, setModal] = React.useState<ReactNode>(null)

    const openSendEmailModal = () => {
        setModal(
            <SendEmailModal
                templateId={docState.emailTemplateId}
                onSubmit={sendByEmail}
                onClose={() => setModal(null)}
                proposalType={STOCK_DOCUMENTS}
                toEmail={toEmail}
                templateKey={"send-stock-document"}
            />
        )
    }

    const sendByEmail = (subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail) => {
        dispatch(ProposalAction.sendByEmail(docState.proposalHash, {
            subject: subject,
            toEmail: toEmail,
            ccEmail: ccEmail,
            bccEmail: bccEmail,
            content: content,
            buttonLabel: buttonLabel,
            fromEmail: fromEmail
        }))
    }

    if (docState.isArchived) {
        return (
            <StaticFooter>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <UnArchiveButton onClickCallback={() => dispatch(StockDocumentAction.unarchive())}/>
                    </div>

                    <div className={"text-warning"}>
                        {props.intl.formatMessage(STOCK_DOCUMENT_FOOTER_MESSAGES.archivedMsg)}
                    </div>
                </div>
            </StaticFooter>
        )
    }

    if (!containsAtLeastOneItem) {
        return (
            <StaticFooter>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <DeleteButtonWithConfirmation onClickCallback={() => dispatch(StockDocumentAction.delete())}/>
                    </div>
                </div>
            </StaticFooter>
        )
    }

    if (docState.isDraft) {
        const isMarkingAsDone = docState.isFetching || isFetching
        return (
            <>
                {modal}
                <StaticFooter>
                    <div className={"d-flex justify-content-between"}>
                        <div>
                            <DeleteButtonWithConfirmation
                                onClickCallback={() => dispatch(StockDocumentAction.delete())}/>

                            <ProposalPreviewButton proposalType={STOCK_DOCUMENT} proposalHash={docState.proposalHash}/>
                        </div>

                        <div>
                            <EditDesignButton proposalHash={docState.proposalHash} editMode={true}/>

                            <MarkAsDoneButton onClickCallback={() => dispatch(StockDocumentAction.markAsDone())} isLoading={isMarkingAsDone}/>

                            {docState.includeContact &&
                                <EmailButton onClickCallback={() => openSendEmailModal()} isLoading={isMarkingAsDone}/>
                            }

                        </div>
                    </div>
                </StaticFooter>
            </>
        )
    }

    if (docState.isInProgress) {
        return (
            <StaticFooter>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <ProposalPreviewButton proposalType={STOCK_DOCUMENT} proposalHash={docState.proposalHash}/>

                        <ProposalOpenButton
                            hash={docState.proposalHash}
                            btnText={props.intl.formatMessage(STOCK_DOCUMENT_FOOTER_MESSAGES.openButtonText)}/>

                        <StockDocumentFooterDropdownMenu/>
                    </div>

                    <div>
                        <InventoryAdjustmentButton
                            buttonName={props.intl.formatMessage(STOCK_DOCUMENT_FOOTER_MESSAGES.receiveItems)}
                            direction={INVENTORY_STOCK_DIRECTION.IN}
                            documentDirection={docState.direction}
                            icon={"boxes"}
                        />
                        <InventoryAdjustmentButton
                            buttonName={props.intl.formatMessage(STOCK_DOCUMENT_FOOTER_MESSAGES.sendItems)}
                            direction={INVENTORY_STOCK_DIRECTION.OUT}
                            documentDirection={docState.direction}
                            icon={"truck-moving"}
                        />
                    </div>
                </div>
            </StaticFooter>
        )
    }

    return (
        <StaticFooter>
            <div className={"d-flex justify-content-between"}>
                <div>
                    <ProposalPreviewButton proposalType={STOCK_DOCUMENT} proposalHash={docState.proposalHash}/>

                    <ProposalOpenButton
                        hash={docState.proposalHash}
                        btnText={props.intl.formatMessage(STOCK_DOCUMENT_FOOTER_MESSAGES.openButtonText)}/>

                    <StockDocumentFooterDropdownMenu/>
                </div>
            </div>
        </StaticFooter>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/components/StockDocumentFooter.tsx